import React from 'react';
import { Formik, Form } from 'formik';
import { Container, Grid, Radio, RadioGroup } from '@material-ui/core';
import BoxWrapper from 'components/atoms/BoxWrapper';
import * as Yup from 'yup';
import 'react-phone-input-2/lib/material.css';
import { time } from 'utils/TimeList';
import FormControlSelectTime from 'components/molecules/FormControlSelectTime';

import FormControlChooseOption from 'components/atoms/FormControlChooseOption';
import CustomTypography from 'components/atoms/CustomTypography';
import { fonts } from 'theme/Variables';
import LinkButton from 'components/atoms/LinkButton';
import { setActiveRadio } from 'utils/SetActiveToRadio';
import { notificationOption } from 'localdata/registerPage/steps/stepNine';
import { carersAllowance } from 'localdata/registerPage/steps/stepSeven';
import Button from 'components/atoms/Button/Button';
import { isDisabled } from 'utils/buttonFormIsDisabled';

const stepNineValidationSchema = Yup.object().shape({
    notification_time: Yup.string().required('Select the notification time!'),
});

const StepNine = ({ setValuesToFormData, nextStep }) => {
    return (
        <Container>
            <BoxWrapper mt="50">
                <Grid container justify="center">
                    <Grid item xs={12} md={4}>
                        <Formik
                            initialValues={{
                                notification_time: '',
                                notification_option: '',
                            }}
                            validationSchema={stepNineValidationSchema}
                            onSubmit={(values, { setSubmitting }) => {
                                setValuesToFormData(values);
                                nextStep('stepTen');
                                setSubmitting(false);
                            }}
                        >
                            {({
                                values,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                isSubmitting,
                                isValid,
                            }) => (
                                <Form onSubmit={handleSubmit}>
                                    <BoxWrapper mb="50" justifyContent="flex-start">
                                        <CustomTypography
                                            variant="h3"
                                            fontSize="2.6"
                                            customfont={fonts.secondary}
                                        >
                                            What time of day (UK time) would you like to receive
                                            your Mobilise Moment?
                                        </CustomTypography>
                                    </BoxWrapper>
                                    <BoxWrapper mb="50" justifyContent="flex-start">
                                        <FormControlSelectTime
                                            name="notification_time"
                                            label="Select time"
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            options={time}
                                            value={values.notification_time}
                                        />
                                    </BoxWrapper>
                                    <BoxWrapper mb="50" justifyContent="flex-start">
                                        <CustomTypography
                                            variant="h3"
                                            fontSize="2.6"
                                            customfont={fonts.secondary}
                                        >
                                            How would you like to receive your Mobilise Moment?
                                        </CustomTypography>
                                    </BoxWrapper>
                                    <BoxWrapper mb="50" justifyContent="flex-start">
                                        <RadioGroup
                                            className="w-100"
                                            name="notification_option"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.notification_option}
                                            defaultValue={values.notification_option}
                                        >
                                            {notificationOption.map(
                                                ({ value, label, instruction, option }) => (
                                                    <FormControlChooseOption
                                                        key={value}
                                                        value={value}
                                                        control={
                                                            <Radio
                                                                color="secondary"
                                                                label={label}
                                                            />
                                                        }
                                                        label={label}
                                                        option={option}
                                                        instruction={instruction}
                                                        labelPlacement="start"
                                                        active={setActiveRadio(
                                                            values.notification_option,
                                                            value,
                                                        )}
                                                    />
                                                ),
                                            )}
                                        </RadioGroup>
                                    </BoxWrapper>
                                    <BoxWrapper>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            mt="20"
                                            width="50"
                                            type="submit"
                                            disabled={isDisabled(values, isValid)}
                                        >
                                            Continue
                                        </Button>
                                    </BoxWrapper>
                                </Form>
                            )}
                        </Formik>
                    </Grid>
                </Grid>
            </BoxWrapper>
        </Container>
    );
};

export default StepNine;
